import { Link } from "react-router-dom";
import { Footer, Header } from "../../components";
import { HeaderType } from "../../components/Header/Header";
import { Section } from "../../components/common";
import { TermsConditionsStyle } from "./TermsConditions.style";

const TermsConditions = () => {
  return (
    <TermsConditionsStyle>
      <Header
        heading="Terms & Conditions"
        image="/images/banners/terms-and-conditions.png"
        type={HeaderType.inner}
      />

      <Section className="testimonial-wrapper">
        <h3>1. Agreement Overview and Booking Terms</h3>
        <p>
          This Agreement is between the Customer and Super Hauling Inc,
          referred to as Super Hauling Inc. Super Hauling Inc acts as
          a booking agent to help arrange vehicle transportation with a licensed
          transport carrier, referred to as the Carrier.
        </p>

        <p>
          For this Agreement, vehicle refers to any vehicle or item being
          shipped by the Carrier through services arranged by Super Hauling Inc. Super Hauling Inc may pre-negotiate rates with carriers
          to help facilitate transport reservations on behalf of the Customer.
        </p>

        <p>
          The total quote may include the Carrier’s transport rate and a booking
          fee retained by Super Hauling Inc for arranging the service. All
          prices are listed in U.S. dollars.
        </p>

        <p>
          Super Hauling Inc is responsible only for arranging transport as
          a broker or booking agent. Super Hauling Inc is not responsible
          for vehicle inspection, loading, transport, delivery, unloading, or
          damage caused during carrier transport. Carrier insurance and carrier
          responsibility apply to transportation-related claims.
        </p>

        <h3>2. Exclusive Agreement Terms</h3>
        <p>
          The Customer agrees not to contract with another broker or carrier
          during the active booking period for the selected shipping option. If
          the Customer works with another broker or carrier during this period,
          the deposit or booking fee may be non-refundable.
        </p>

        <h3>3. Door-to-Door Transport Guidelines</h3>
        <p>
          Door-to-door transport is provided when the Carrier can safely access
          the pickup and delivery addresses. If access is restricted by narrow
          streets, low-hanging trees, tight turns, local rules, or unsafe
          conditions, the driver may ask the Customer to meet at a nearby safe
          location, such as a large parking lot.
        </p>

        <h3>4. Personal Items and Loading Guidelines</h3>
        <p>
          Super Hauling Inc and the Carrier are not responsible for
          personal or household items placed inside the vehicle. These items are
          not covered by Super Hauling Inc or Carrier insurance.
        </p>

        <p>
          If personal items are placed inside the vehicle, the Customer must
          inform Super Hauling Inc in advance. The Carrier may refuse or
          charge additional fees for personal items. The Customer must not place
          firearms, illegal substances, explosives, flammable items, or
          prohibited goods inside the vehicle.
        </p>

        <h3>5. Vehicle Condition and Liability</h3>
        <p>
          Vehicles must be provided to the Carrier in safe transport condition
          with no more than a half tank of fuel unless otherwise disclosed. The
          Carrier is not responsible for damage caused by leaking fluids,
          freezing, loose parts, antennas, exhaust systems, or pre-existing
          mechanical issues.
        </p>

        <p>
          Any claim for loss or damage must be noted on the Bill of Lading or
          condition report at delivery and signed by the driver.
        </p>

        <h3>6. Insurance Coverage and Claims Process</h3>
        <p>
          Vehicle transport damage claims are handled through the Carrier’s
          insurance provider. Carrier insurance coverage may vary depending on
          the Carrier and shipment type.
        </p>

        <p>
          Any damage during transport is the responsibility of the Carrier and
          not Super Hauling Inc. Super Hauling Inc may assist by
          providing Carrier insurance information when available.
        </p>

        <p>
          Damage must be clearly noted on the Bill of Lading or final inspection
          report at the time of delivery and signed by the driver. Claims should
          be submitted in writing within 15 days of delivery.
        </p>

        <h3>7. Rescheduling and Additional Fees</h3>
        <p>
          The Carrier and Super Hauling Inc will make reasonable efforts to
          notify the Customer before pickup and delivery. The Customer is
          responsible for being available at the agreed location and having any
          required payment ready when the Carrier arrives.
        </p>

        <p>
          If the Customer is unavailable, the Customer must designate a person
          over 18 years old to act on their behalf. Delays caused by failure to
          release or receive the vehicle may result in a rescheduling fee of
          $75.00.
        </p>

        <h3>8. Vehicle Release and Inspection Procedures</h3>
        <p>
          The Customer should not release or receive a vehicle without an
          inspection report or Bill of Lading. Failure to review and sign the
          Bill of Lading may affect the Customer’s ability to file a claim.
        </p>

        <p>
          If damage is found at delivery, the Customer must note the damage on
          the final inspection report, pay any remaining balance stated in the
          agreement, and contact the Carrier’s office and insurance company.
          Transport damage claims must be made with the Carrier.
        </p>

        <h3>9. Refunds and Cancellation</h3>
        <p>
          Cancellation requests must be made in writing by email or other
          electronic communication. If the Customer cancels within 24 hours of
          placing an order and no Carrier has been assigned, Super Hauling Inc may refund eligible amounts minus any fees already incurred.
        </p>

        <p>
          Domestic booking requests active longer than 24 hours without a
          reservation may be subject to a $75.00 administrative fee. Bookings
          with assigned carriers or confirmed reservations may be
          non-refundable.
        </p>

        <h3>10. Pricing Adjustments and Re-Quoting</h3>
        <p>
          Transport prices may change due to market conditions, fuel costs,
          route availability, Carrier demand, or shipment requirements. If a
          price adjustment is required, Super Hauling Inc will contact the
          Customer before proceeding.
        </p>

        <p>
          If the Customer refuses the adjusted price, Super Hauling Inc may
          continue searching for a Carrier at the original quoted price, but
          this may delay dispatch and transport.
        </p>

        <h3>11. Shipping Terms and Guarantees</h3>
        <p>
          Super Hauling Inc does not guarantee pickup or delivery dates or
          times. All dates and times are estimates only. Delays may occur due to
          weather, traffic, Carrier availability, mechanical issues, road
          conditions, regulations, or other circumstances beyond control.
        </p>

        <p>
          Super Hauling Inc is not responsible for rental costs, missed
          events, market losses, lost time, or other costs resulting from
          transport delays.
        </p>

        <h3>12. SMS Terms & Conditions</h3>

        <h4>12.1 SMS Consent Communication</h4>
        <p>
          The information obtained as part of the SMS consent process, including
          phone numbers, will not be shared with third parties for marketing
          purposes.
        </p>

        <h4>12.2 Types of SMS Communications</h4>
        <p>
          If you have consented to receive text messages from Super Hauling Inc, you may receive messages related to the following:
        </p>
        <ul>
          <li>Vehicle transport booking confirmations</li>
          <li>Pickup and delivery scheduling updates</li>
          <li>Driver and carrier assignment notifications</li>
          <li>Shipping status and tracking updates</li>
          <li>Payment reminders and invoice notifications</li>
          <li>Customer support follow-ups regarding your shipment</li>
        </ul>

        <h4>12.3 Message Frequency</h4>
        <p>
          Message frequency may vary depending on your interaction with us. You
          may receive up to 10 SMS messages per week regarding vehicle transport
          quotes, booking confirmations, dispatch updates, delivery
          coordination, payment reminders, and customer support.
        </p>

        <h4>12.4 Potential Fees for SMS Messaging</h4>
        <p>
          Standard message and data rates may apply depending on your mobile
          carrier’s pricing plan. These fees may vary for domestic or
          international messages.
        </p>

        <h4>12.5 Opt-In Method</h4>
        <p>
          You may opt in to receive SMS messages from Super Hauling Inc
          in the following ways:
        </p>
        <ul>
          <li>By submitting a quote request form on our website</li>
          <li>By filling out a contact or booking form</li>
          <li>
            By verbally providing consent during a phone call with our
            representatives
          </li>
          <li>By requesting vehicle transport services from our company</li>
        </ul>

        <h4>12.6 Opt-Out Method</h4>
        <p>
          You can opt out of receiving SMS messages at any time by replying STOP
          to any SMS message you receive. You may also contact us directly to
          request removal from our messaging list.
        </p>

        <h4>12.7 Help</h4>
        <p>
          If you are experiencing any issues, you can reply HELP for assistance.
          You may also contact us directly through our{" "}
          <Link to="/contact-us">Contact Us</Link> page.
        </p>

        <h4>12.8 Additional Options</h4>
        <p>
          If you do not wish to receive SMS messages, you can choose not to
          check the SMS consent box on our forms.
        </p>

        <h4>12.9 Standard Messaging Disclosures</h4>
        <ul>
          <li>Message and data rates may apply</li>
          <li>You can opt out at any time by texting STOP</li>
          <li>
            For assistance, text HELP or visit our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
            <Link to="/terms-conditions">Terms & Conditions</Link> pages
          </li>
          <li>
            Message frequency may vary. You may receive up to 10 SMS messages
            per week.
          </li>
        </ul>

        <h3>13. Legal Jurisdiction and Agreement</h3>
        <p>
          This agreement shall be governed by and construed under the laws of
          the State of Georgia, unless otherwise required by applicable law. The
          parties agree that any legal action arising out of this agreement must
          be filed in a court of proper jurisdiction.
        </p>

        <p>
          Super Hauling Inc’s liability, if any, shall be limited to the
          amount of Super Hauling Inc’s broker fee only. The Customer
          agrees to the transport terms provided by Super Hauling Inc and
          authorizes any applicable down payment or booking fee through approved
          payment methods.
        </p>

        <p>
          Any remaining balance is due upon delivery and must be paid in full to
          the authorized transporter through the agreed payment method.
        </p>

        <h3>14. Contact Information</h3>
        <p>
          Super Hauling Inc
          <br />
          500 Rawhide Ln, Florence, TX 76527
          <br />
          Phone: (888) 693-9563
          <br />
              Email: info@superspeedhauling.us
        </p>
      </Section>

      <Footer />
    </TermsConditionsStyle>
  );
};

export default TermsConditions;


